var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "license-information py-3" },
    [
      _c(
        "validation-observer",
        { ref: "formValidator" },
        [
          _c("div", { staticClass: "body pt-4" }, [
            _c("div", { staticClass: "container-fluid pdr-0 mgr-0" }, [
              _c(
                "div",
                { staticClass: "col ml-2 pdr-0 mgr-0 mb-2" },
                [
                  _c("label", { staticClass: "data-label d-block" }, [
                    _vm._v(" ¿La Licencia es Provisional? ")
                  ]),
                  _c("validation-provider", {
                    attrs: { rules: "required" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function({ errors }) {
                          return [
                            _c("custom-radio", {
                              key: String(_vm.provisionalFlag?.value),
                              attrs: {
                                "custom-error-msg":
                                  "Favor de seleccionar si la licencia es provisional o no",
                                error: errors[0],
                                "is-inline": "",
                                name: "rbRecurrenceType",
                                options: _vm.provisionalOptions
                              },
                              on: { input: _vm.provisionalFlagChanged },
                              model: {
                                value: _vm.provisionalFlag,
                                callback: function($$v) {
                                  _vm.provisionalFlag = $$v
                                },
                                expression: "provisionalFlag"
                              }
                            })
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _c("div", { staticClass: "row mx-2" }, [
                _c(
                  "div",
                  { staticClass: "col-sm-12 col-md-3 mb-3" },
                  [
                    _c("validation-provider", {
                      attrs: {
                        name: "LicenseType",
                        rules: { required: true, notEmptyObject: "id" }
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function({ errors }) {
                            return [
                              _c("custom-drop-down", {
                                attrs: {
                                  "custom-error-msg":
                                    "Favor de seleccionar una Especialidad",
                                  disabled:
                                    _vm.license.specialistLicenseId != null,
                                  error: errors[0],
                                  fieldkey: "id",
                                  fieldname: "name",
                                  label: "Especialidad:",
                                  options: _vm.filteredSpecialtyTypes,
                                  placeholder: "Seleccione",
                                  reduce: o => ({ id: o.id, name: o.name })
                                },
                                on: { input: _vm.onChangeSpecialtyHandler },
                                model: {
                                  value: _vm.selectedSpecialty,
                                  callback: function($$v) {
                                    _vm.selectedSpecialty = $$v
                                  },
                                  expression: "selectedSpecialty"
                                }
                              })
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                ),
                _vm.isPsychologist
                  ? _c(
                      "div",
                      { staticClass: "col-sm-12 col-md-3" },
                      [
                        _c("label", { staticClass: "data-title mb-0" }, [
                          _vm._v("Nivel de Especialista:")
                        ]),
                        _c("validation-provider", {
                          attrs: {
                            name: "licenseSpecialtyType",
                            rules: "required"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-drop-down", {
                                      attrs: {
                                        "custom-error-msg":
                                          "El nivel de especialista es requerido.",
                                        error: errors[0],
                                        fieldkey: "id",
                                        fieldname: "name",
                                        options: _vm.levelTypes,
                                        placeholder: "Seleccione"
                                      },
                                      model: {
                                        value:
                                          _vm.specialistLicense.specialtyLevel,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.specialistLicense,
                                            "specialtyLevel",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "specialistLicense.specialtyLevel"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            94618236
                          )
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.hasDetail
                  ? _c(
                      "div",
                      { staticClass: "col-sm-12 col-md-3 mb-3" },
                      [
                        _c("validation-provider", {
                          attrs: { name: "LicenseNo", rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-input", {
                                      attrs: {
                                        "custom-error-msg":
                                          _vm.validationMessages.licenseNo,
                                        disabled: _vm.cantEditLicenseNo,
                                        error: errors[0],
                                        label: "Número de Licencia:"
                                      },
                                      model: {
                                        value: _vm.specialistLicense.licenseNo,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.specialistLicense,
                                            "licenseNo",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "specialistLicense.licenseNo"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2141452364
                          )
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.hasDetail
                  ? _c(
                      "div",
                      { staticClass: "col-sm-12 col-md-3 mb-3" },
                      [
                        _c("validation-provider", {
                          attrs: {
                            name: "LicenseExpireDate",
                            rules: "required"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-date-picker", {
                                      staticClass: "w-100",
                                      attrs: {
                                        "custom-error-msg":
                                          _vm.validationMessages
                                            .licenseExpireDate,
                                        error: errors[0],
                                        label: "Fecha de Expiración:",
                                        "min-date": new Date()
                                      },
                                      model: {
                                        value:
                                          _vm.specialistLicense
                                            .licenseExpireDate,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.specialistLicense,
                                            "licenseExpireDate",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "specialistLicense.licenseExpireDate"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3886266452
                          )
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.hasDetail
                  ? _c(
                      "div",
                      { staticClass: "col-sm-12 col-md-3 mb-3" },
                      [
                        _c("validation-provider", {
                          attrs: {
                            name: "AgeRange",
                            rules: { required: true, notEmptyObject: "id" }
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-drop-down", {
                                      attrs: {
                                        "custom-error-msg":
                                          _vm.validationMessages.ageRange,
                                        error: errors[0],
                                        fieldkey: "id",
                                        fieldname: "name",
                                        label: "Rango de Edad:",
                                        options: _vm.ageRanges,
                                        placeholder: "Seleccione",
                                        reduce: o => ({
                                          id: o.id,
                                          name: o.name
                                        })
                                      },
                                      model: {
                                        value: _vm.selectedAgeRange,
                                        callback: function($$v) {
                                          _vm.selectedAgeRange = $$v
                                        },
                                        expression: "selectedAgeRange"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3522204449
                          )
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "col-sm-6 col-md mb-3" },
                  [
                    _vm.hasDetail && _vm.showSupervisorCheck
                      ? _c("check-box", {
                          staticClass: "checkbox",
                          attrs: { text: "Supervisor" },
                          model: {
                            value: _vm.specialistLicense.supervisorFlag,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.specialistLicense,
                                "supervisorFlag",
                                $$v
                              )
                            },
                            expression: "specialistLicense.supervisorFlag"
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ]),
              _vm.isMedicaidDocumentationWorkflowEnabled
                ? _c("div", { staticClass: "row mx-2" }, [
                    _c("div", { staticClass: "col-sm" }, [
                      _c(
                        "div",
                        { staticClass: "mt-1" },
                        [
                          _c("custom-input", {
                            attrs: {
                              disabled: _vm.disabled,
                              label: "Medicaid ID:",
                              maxlength: "50",
                              placeholder: "Ingrese el Medicaid ID"
                            },
                            model: {
                              value: _vm.specialistLicense.medicalIdentifier,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.specialistLicense,
                                  "medicalIdentifier",
                                  $$v
                                )
                              },
                              expression: "specialistLicense.medicalIdentifier"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _c(
                      "div",
                      { staticClass: "col-sm" },
                      [
                        _c("custom-date-picker", {
                          attrs: {
                            "class-container": "w-100",
                            format: "dd/MMM./yyyy",
                            label: "Fecha de Vencimiento Medicaid:",
                            "min-date": _vm.currentDate
                          },
                          model: {
                            value: _vm.specialistLicense.medicaidDueDate,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.specialistLicense,
                                "medicaidDueDate",
                                $$v
                              )
                            },
                            expression: "specialistLicense.medicaidDueDate"
                          }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm.hasSpecialistCertificationsEnable && _vm.isAdvisor
                ? _c("div", { staticClass: "row ml-2 pdr-0 mgr-0" }, [
                    _c("div", { staticClass: "col-12 text-muted" }, [
                      _c("span", [_vm._v("Certificaciones:")])
                    ]),
                    _c(
                      "div",
                      { staticClass: "col-12 d-flex" },
                      [
                        _c("check-box", {
                          staticClass: "checkbox",
                          attrs: {
                            text: "CVE - Certified Vocational Evaluator"
                          },
                          model: {
                            value: _vm.specialistLicense.isCVE,
                            callback: function($$v) {
                              _vm.$set(_vm.specialistLicense, "isCVE", $$v)
                            },
                            expression: "specialistLicense.isCVE"
                          }
                        }),
                        _c("check-box", {
                          staticClass: "checkbox",
                          attrs: {
                            text:
                              "ICVE - International Certified Vocational Evaluator"
                          },
                          model: {
                            value: _vm.specialistLicense.isICVE,
                            callback: function($$v) {
                              _vm.$set(_vm.specialistLicense, "isICVE", $$v)
                            },
                            expression: "specialistLicense.isICVE"
                          }
                        }),
                        _c("check-box", {
                          staticClass: "checkbox",
                          attrs: {
                            text: "CEV - Certificado en Evaluación Vocacional"
                          },
                          model: {
                            value: _vm.specialistLicense.isCEV,
                            callback: function($$v) {
                              _vm.$set(_vm.specialistLicense, "isCEV", $$v)
                            },
                            expression: "specialistLicense.isCEV"
                          }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e()
            ])
          ]),
          _c(
            "div",
            { staticClass: "pl-4" },
            [
              _c("license-documents", {
                on: {
                  "delete-document": _vm.deleteDocument,
                  "download-document": _vm.downloadDocument
                },
                model: {
                  value: _vm.specialistLicense,
                  callback: function($$v) {
                    _vm.specialistLicense = $$v
                  },
                  expression: "specialistLicense"
                }
              })
            ],
            1
          ),
          _vm.customErrorMessage != null
            ? _c("error", {
                attrs: { message: _vm.customErrorMessage, variant: "no-border" }
              })
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "d-flex justify-content-end" },
        [
          _c("action-button", {
            staticClass: "py-2 btnCancel",
            attrs: {
              i: "fas fa-times-circle",
              text: "Cancelar",
              variant: "outline-danger"
            },
            on: { click: _vm.cancel }
          }),
          _c("action-button", {
            staticClass: "mx-3",
            attrs: { i: "fas fa-plus", text: "Guardar", variant: "success" },
            on: { click: _vm.save }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }